import {AfterViewInit, Directive, ElementRef, HostBinding, Renderer2} from '@angular/core';
import {MatSortHeader} from '@angular/material/sort';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {startWith} from 'rxjs/operators';

@UntilDestroy()
@Directive({
    selector: '[mat-sort-header]',
})
export class CustomMatSortHeaderDirectionDirective implements AfterViewInit {
    private arrowEl: HTMLElement | null = null;
    isSortDisabled!: boolean;

    @HostBinding('class.sorting-empty')
    get isSortNotActive(): boolean {
        return this.isSortDisabled;
    }

    constructor(
        private matSortHeader: MatSortHeader,
        private hostEl: ElementRef<HTMLElement>,
        private renderer: Renderer2
    ) {}

    ngAfterViewInit(): void {
        this.arrowEl = this.hostEl.nativeElement.querySelector('.mat-sort-header-arrow');

        if (!this.arrowEl) {
            return;
        }

        queueMicrotask(() => {
            this.matSortHeader._sort.sortChange
                .pipe(startWith(null), untilDestroyed(this))
                .subscribe(() => {
                    const ariaSort = this.matSortHeader._getAriaSortAttribute();

                    this.isSortDisabled = ariaSort === 'none';

                    let iconHtml = '';
                    switch (ariaSort) {
                        case 'ascending':
                            iconHtml = '<i class="hgi hgi-stroke hgi-sorting-03 ascending"></i>';
                            break;
                        case 'descending':
                            iconHtml = '<i class="hgi hgi-stroke hgi-sorting-03 descending"></i>';
                            break;
                        default:
                            iconHtml = '<i class="hgi hgi-stroke hgi-arrow-up-down"></i>';
                            break;
                    }

                    this.renderer.setProperty(this.arrowEl, 'innerHTML', iconHtml);
                });
        });
    }
}
